module.exports = __webpack_public_path__ + "static/emm-003-f0abc2c02bfe65b6f8ec01eaa17c3e35.jpg";